export default function QueueHint({ queue, deferred = false }) {
  const { items, ready, previewed, allPreviewed } = queue

  if (ready.length === 0) {
    return items.some((item) => item.status === 'error') ? 'Retry or remove the failed files' : "Remove the files that can't be uploaded"
  }
  if (!allPreviewed) return `Preview each file before uploading · ${previewed.length} of ${ready.length} previewed`
  if (deferred) return `${ready.length > 1 ? `${ready.length} files` : 'File'} previewed · uploaded when the escalation is added`
  return `${ready.length > 1 ? `${ready.length} files` : 'File'} ready`
}
